package pl.decks.personal.pages.ievp.foreword

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.toModifier
import pl.decks.personal.components.layouts.site.SiteLayoutStylesheet
import pl.decks.personal.pages.ievp.IEVPStylesheet
import pl.decks.personal.styles.SiteLayout

@Composable
fun AtriaForeword() = Column(
    modifier = SiteLayoutStylesheet.Page.Content.toModifier()
        .padding(left = IEVPStylesheet.Vars.contentPaddingLeft.value(), top = SiteLayout.Space.Medium),
    horizontalAlignment = Alignment.CenterHorizontally,
) {
    CoverLetterText(
        "I read the world by numbers. The ones on healthcare are unkind, and so far the only way I found to grace them is to accelerate the shift from Fee-For-Service to Value-Based Care. It could be an excerpt from your mission statement, but actually this conclusion I came to way before I knew Atria existed. It's a premise on which I started my startup, Exura.",
        "The company is still running, without me. Working there was exciting, but in a way - isolating. Solo, behind closed doors, with no-one to discuss the struggles healthcare is facing. I kept circling back to the thought that more can be done alongside people just as obsessed - focusing on my strengths and prior experience. Utilising data.",
        "I found Atria to be operating on principles that are close to me - openness, empathy and generosity. The Academy and Library initiatives tell me that's true, and I would be devastated if that turned out to be a facade.",
        "Myself? Everything you read here is open source. I could hide my failures and shortcomings, but didn't. The hiring process, with no cards up either sleeve, is both better and fairer.",
    )
}
